if ( typeof PincodeChecker !== 'function' ) {

	class PincodeChecker extends HTMLElement {

		constructor(){
			super();

			this.input = this.querySelector('[data-js-pincode-input]');
			this.button = this.querySelector('[data-js-pincode-check]');
			this.message = this.closest('.additional-info-block__delivery')?.querySelector('[data-js-pincode-message]');

			this.button.addEventListener('click', this.onCheck.bind(this));
			this.input.addEventListener('keydown', e => {
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					e.preventDefault();
					this.onCheck();
				}
			});
		}

		onCheck(){
			if ( ! this.message ) return;

			const value = this.input.value.trim();

			this.message.classList.remove('is-valid', 'is-invalid');

			if ( /^[1-9][0-9]{5}$/.test(value) ) {
				this.message.textContent = 'Delivery is available for this pincode.';
				this.message.classList.add('is-valid');
			} else {
				this.message.textContent = 'Please enter a valid 6-digit pincode.';
				this.message.classList.add('is-invalid');
			}
		}

	}

	if ( typeof customElements.get('pincode-checker') == 'undefined' ) {
		customElements.define('pincode-checker', PincodeChecker);
	}

}
